import type { FocusEvent, FocusEventHandler } from "react";

export function onElementBlur<E extends HTMLElement>(h: FocusEventHandler<E>) {
    return (e: FocusEvent<E>) => !e.currentTarget?.contains(e.relatedTarget) && h(e);
}